import React from 'react';
import { X, Zap, RefreshCw } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

interface RefillModalProps {
    isOpen: boolean;
    onClose: () => void;
    onRefill: () => void;
}

export function RefillModal({ isOpen, onClose, onRefill }: RefillModalProps) {
    const { user } = useAuth();

    if (!isOpen) return null;

    const planName = user?.maxCredits === 200 ? 'Starter Pack' : 'Growth Pack';
    const planPrice = user?.maxCredits === 200 ? '$9' : '$19';
    const planCredits = user?.maxCredits || 0;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-background rounded-xl w-full max-w-md shadow-2xl p-6 scale-100 animate-in zoom-in-95 duration-200">
                <div className="flex flex-col items-center text-center">
                    <div className="p-3 bg-yellow-500/10 rounded-full mb-4">
                        <Zap className="h-8 w-8 text-yellow-600 dark:text-yellow-500" />
                    </div>
                    <h3 className="text-xl font-bold text-foreground mb-2">Credits Depleted</h3>
                    <p className="text-muted-foreground mb-6 text-sm">
                        You've used all your credits from your <span className="font-semibold text-foreground">{planName}</span>.
                        <br />
                        Refill to continue using the API.
                    </p>

                    <div className="w-full bg-muted/30 rounded-lg p-4 mb-6">
                        <div className="flex items-center justify-between mb-2">
                            <span className="text-sm font-medium text-muted-foreground">Refill Plan</span>
                            <span className="text-2xl font-bold text-foreground">{planPrice}</span>
                        </div>
                        <p className="text-sm text-primary font-medium">
                            {planCredits} Credits
                        </p>
                    </div>

                    <div className="flex gap-4 w-full">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-2 rounded-lg border border-border hover:bg-muted font-medium transition-colors text-foreground"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onRefill}
                            className="flex-1 px-4 py-2 rounded-lg bg-primary hover:bg-primary/90 text-primary-foreground font-medium transition-colors flex items-center justify-center gap-2"
                        >
                            <RefreshCw className="h-4 w-4" />
                            Refill Now
                        </button>
                    </div>

                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 p-2 hover:bg-accent rounded-full transition-colors"
                    >
                        <X className="h-5 w-5 text-muted-foreground" />
                    </button>
                </div>
            </div>
        </div>
    );
}
